import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { listUsers, closeUserSuccess, createInviteUser } from '../../actions/user';
import { getAccountById } from '../../actions/superadmin';
import { storeWithExpiration } from '../../utils/common';
import { openDialog, closeDialog } from '../../actions/dialog';
import { PROVIDER_ADMIN, SUPER_ADMIN } from '../../config/app_config';
import UserInviteFormContainer from './UserInviteFormContainer';
import UserResendInviteContainer from './UserResendInviteContainer';
import UserInviteSuccessContainer from './UserInviteSuccessContainer';

import UsersIndex from './UsersIndex';

export class UsersIndexContainer extends React.Component {
  static propTypes = {
    accountId: PropTypes.number.isRequired,
    currAccount: PropTypes.object.isRequired,
    closeDialogAction: PropTypes.func.isRequired,
    dialog: PropTypes.object.isRequired,
    isProviderAdmin: PropTypes.bool.isRequired,
    isSuperAdmin: PropTypes.bool.isRequired,
    getAccountByIdAction: PropTypes.func.isRequired,
    listUsersAction: PropTypes.func.isRequired,
    openDialogAction: PropTypes.func.isRequired,
    userInvite: PropTypes.object.isRequired,
    userList: PropTypes.object.isRequired,
  };

  state = {
    userSelected: {},
    activeUser: {},
  };

  // Fetch users for specified users account logged in user if non-admin, desired viewing user if
  // datarista admin
  componentWillMount = () => {
    const { accountId, listUsersAction, getAccountByIdAction } = this.props;
    const token = storeWithExpiration.get('token');
    listUsersAction(accountId, token);
    getAccountByIdAction(accountId, token);
  };

  componentWillUnmount = () => {
    const { dialog, closeDialogAction } = this.props;
    if (dialog.show) {
      closeDialogAction(dialog.id);
    }
  };

  setUserSelected = user => {
    this.setState({
      userSelected: user,
    });
  };

  toggleActiveUser = user => {
    this.setState(prevState => {
      if (prevState.activeUser.id === user.id) {
        return { activeUser: {} };
      }
      return { activeUser: user };
    });
  };

  toggleDialog = id => {
    const { dialog, openDialogAction, closeDialogAction } = this.props;
    if (
      (dialog.show && dialog.id === 'addUserDialog') ||
      (dialog.show && dialog.id === 'resendInviteDialog')
    ) {
      closeDialogAction(id);
    } else {
      openDialogAction(id);
    }
  };

  cancelDialog = id => {
    const { closeDialogAction } = this.props;
    closeDialogAction(id);
  };

  handleClickNewUser = id => () => {
    this.toggleDialog(id);
  };

  renderInviteDialog = () => {
    const { currAccount, userInvite, dialog } = this.props;
    return (
      <UserInviteFormContainer
        accountId={currAccount.get('id')}
        cancelDialogFunction={this.cancelDialog}
        userInvite={userInvite}
        show={dialog.show}
        successFunction={this.toggleDialog}
      />
    );
  };

  renderResendInviteDialog = () => {
    const { dialog } = this.props;
    const { userSelected } = this.state;

    return (
      <UserResendInviteContainer
        cancelDialogFunction={this.cancelDialog}
        show={dialog.show}
        user={userSelected}
        successFunction={this.toggleDialog}
      />
    );
  };

  renderSuccessDialog = () => {
    const { userInvite, dialog } = this.props;

    return (
      <UserInviteSuccessContainer
        cancelDialogFunction={this.cancelDialog}
        userInvite={userInvite}
        show={dialog.show}
        successFunction={this.toggleDialog}
      />
    );
  };

  render() {
    const { currAccount, dialog, isProviderAdmin, isSuperAdmin, userList, userInvite } = this.props;
    const { activeUser } = this.state;

    return (
      <div className="modal-wrap">
        <div className="container-fluid container-home">
          <div className="header">
            <div className="header-body align-items-center">
              <div className="row">
                <div className="col-md-10">
                  <h1 className="header-title">Users</h1>
                  {isSuperAdmin ? (
                    <p>
                      <strong>Company: </strong>
                      {currAccount.get('companyName')}
                    </p>
                  ) : null}
                </div>
                <div className="col-md-2">
                  <span>
                    {isProviderAdmin || isSuperAdmin ? (
                      <button
                        className="btn btn-primary pull-right"
                        onClick={this.handleClickNewUser('addUserDialog')}
                      >
                        Create
                      </button>
                    ) : null}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <UsersIndex
            activeUser={activeUser}
            users={userList.get('users')}
            isProviderAdmin={isProviderAdmin}
            isSuperAdmin={isSuperAdmin}
            setUserSelected={this.setUserSelected}
            toggleActiveUser={this.toggleActiveUser}
            toggleDialog={this.toggleDialog}
          />
          {dialog.id === 'addUserDialog' && dialog.show
            ? this.renderInviteDialog(dialog.accountId)
            : null}
          {dialog.id === 'resendInviteDialog' && dialog.show
            ? this.renderResendInviteDialog()
            : null}
          {userInvite.hasSecond &&
          userInvite.isSecond &&
          (dialog.id === 'successDialog' && dialog.show)
            ? this.renderSuccessDialog()
            : null}
        </div>
      </div>
    );
  }
}

// Get user list for an account and user state from redux and map it to presentation layer
const mapStateToProps = (state, ownProps) => {
  const { account, userList, user, dialog, userInvite, superadmin } = state;
  const { params } = ownProps;
  const isSuperAdmin = user.get('userTypeId') === SUPER_ADMIN;
  const isProviderAdmin = user.get('userTypeId') === PROVIDER_ADMIN;
  const currAccount = superadmin.get('currAccount');
  let accountId = account.get('id');
  if (isSuperAdmin && params) {
    accountId = parseInt(params.accountId, 10);
  }

  return {
    accountId,
    currAccount,
    dialog,
    isProviderAdmin,
    isSuperAdmin,
    userList,
    userInvite,
  };
};

// Connect to redux store and fetch the list of users for the invoked accountId and token
export default connect(
  mapStateToProps,
  {
    listUsersAction: listUsers,
    getAccountByIdAction: getAccountById,
    openDialogAction: openDialog,
    closeDialogAction: closeDialog,
    closeUserSuccessAction: closeUserSuccess,
    inviteUserAction: createInviteUser,
  }
)(UsersIndexContainer);
